import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TABLES } from '../../../../../Apis/Tables';
import {
    roleAvailableTasks,
} from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { useNavigate } from 'react-router-dom';
import PrivilegeDetails from '../Subcomponents/PrivilegeDetails';
import { permissionObj } from '../../../../../Helpers/permission';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import routes from '../../../../../Routes/routes';
import { DetailsIconsOptions, UpdateIconsOptions } from '../../../../../components/buttons/IconButtons';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import TableFunction from '../../../../../components/table/TableFunction';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import { toast } from 'react-toastify';
import { ROLE_NAME_DEFAULT_MODEL } from '../../../../../enums/userTypeEnum';
import {errorMsg} from "../../../../../Apis/functions";
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const RolesPanelLogic = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [selectRoleForDelete, setSelectRoleForDelete] = useState([]);
    const [roleShow, setRoleShow] = useState(false);
    const [modified,setModified] = useState(false)
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState();
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [resultsToShow, setResultsToShow] = useState('');
    const option = TABLES.ROLE;
    const navigate = useNavigate();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, key: searchElement, model: option });
        dispatch(roleAvailableTasks());
        dispatch(SimpleSearch({ body })).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    setResultsToShow(data);
                }
            },
        );
    };

    const { handleCheckboxChange, handleDeleteAll, handleClose, pagination, page, rowsPerPage, openMenu, handleMenuToggle } =
        TableFunction({
            selectedList: selectRoleForDelete,
            setSelectedList: setSelectRoleForDelete,
            data: resultsToShow,
            labelRowsPerPage: 'privileges_per_page',
            setIsAllChecked,
            fixedPagination: false,

            searchElement, //New
            getData,//New
            modified,//New
            setModified,//New
        });


    // api function to delete roles
    const deleteRoles = (deleteItem) => {
        const body = deleteItem;
        dispatch(DeleteItemsApi({ tableName:TABLES.ROLE, body })).then(({payload: {data: {  success, code }}}) => {
            if (success === true) {
                setSelectRoleForDelete([]);
                setIsAllChecked(false);
                setModified(true)
            }else errorMsg(code)
        });
    };

    const columns = [{ field: 'name', label: 'name' }];

    const handleRowExpand = (row) => {};

    const renderOptionsMenu = (row, index) => {
        const canUpdate = !Object.values(ROLE_NAME_DEFAULT_MODEL).includes(row?.name?.toUpperCase());
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${row.id}`}>
                    {(DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_UPDATE)) && (
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t(canUpdate ?'update' : 'details')}
                            click={() => navigate(`${routes.roles.update}${row?.id}`)}
                            icon={canUpdate ? <UpdateIconsOptions /> : <DetailsIconsOptions />}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        );
    };

    const handleDelete = () => {

        /**
         * Check if any of the selected role IDs correspond to a role
         * whose name is in ROLE_NAME_DEFAULT_MODEL
         */
        const hasExceptionRole = resultsToShow?.content?.some(role =>
            selectRoleForDelete.includes(role.id) && // if this role is selected
            Object.values(ROLE_NAME_DEFAULT_MODEL).includes(role.name?.toUpperCase()) // and it's an exception role
        );

        if (hasExceptionRole) {
            toast.error(t('you_cannot_delete_root_or_guard_roles'));
            return;
        }

        setRoleShow(true);
    };

    return {
        t,
        DEV,
        handleRowExpand,
        renderOptionsMenu,
        columns,
        handleCheckboxChange,
        deleteRoles,
        setIsAllChecked,
        selectRoleForDelete,
        roleShow,
        setRoleShow,
        searchElement,
        setSearchElement,
        option,
        page,
        rowsPerPage,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        setSelectRoleForDelete,
        permission,
        navigate,
        dispatch,
        resultsToShow,
        pagination,
        setResultsToShow,
        handleDeleteAll,
        PrivilegeDetails,
        setBodyForExport,
        handleDelete
    };
};
export default RolesPanelLogic;
